module.exports = __webpack_public_path__ + "img/feature_3.2867b2d7.svg";